import React from 'react';

import { ToastProvider } from './HousePage/toastContext';
import HousePageContent from './HousePage/HousePageContent';

const HousePageWithToast = (props) => {
    return (
        <ToastProvider>
            <HousePageContent {...props} />
        </ToastProvider>
    );
};

/*

Страница разбита на логические модули:
- HousePageWithToast.jsx — точка входа;
- HousePageContent.jsx — основная логика страницы;
модальные окна лежат отдельно;
- тосты вынесены в отдельный контекст;
- константы и хелперы вынесены отдельно;
- устройства и карточка узла вынесены отдельно.

статусы узла — в EditNodeStatusModal.jsx;
создание устройства — в CreateDeviceModal.jsx;
редактирование устройства — в EditDeviceModal.jsx;
акты — в UploadActModal.jsx и ViewActsModal.jsx;
внешний вид узла — в MeteringNodeCard.jsx.

*/


export default HousePageWithToast;